import { render, staticRenderFns } from "./PoliticalWork.vue?vue&type=template&id=3ecb641c&scoped=true"
import script from "./PoliticalWork.vue?vue&type=script&lang=js"
export * from "./PoliticalWork.vue?vue&type=script&lang=js"
import style0 from "./PoliticalWork.vue?vue&type=style&index=0&id=3ecb641c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecb641c",
  null
  
)

export default component.exports